module.exports = __webpack_public_path__ + "img/solarlogo.4645f131.png";